
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  constructor(private http: HttpClient) {
  }

  getCategories(): Observable<any[]> {
    return this.http.get<any>(`${this.endpoint}/categories`);
  }

  getLocations(): Observable<any[]> {
    return this.http.get<any>(`${this.endpoint}/locations`);
  }

  private get endpoint(): string {
    return `${environment.apiUrl}/partners`;
  }
}
